import { render } from "./ExternalNavigation.vue?vue&type=template&id=ded82e08"
import script from "./ExternalNavigation.vue?vue&type=script&lang=js"
export * from "./ExternalNavigation.vue?vue&type=script&lang=js"

import "./ExternalNavigation.vue?vue&type=style&index=0&id=ded82e08&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__